import Vue from 'vue';
import Locale from './../vue-i18n-locales.generated';
import env from '../env';
import calcHeight from './mixins/calcHeightContent'
import eventBus from './eventBus'

import VueInternationalization from 'vue-i18n';
Vue.use(VueInternationalization);
Vue.mixin(calcHeight)

const i18n = new VueInternationalization({
    locale: localStorage.getItem('language') ? localStorage.getItem('language') : 'ua',
    messages: Locale
});

Object.defineProperty(Vue.prototype, '$locale', {
    get: function () {
        return i18n.locale
    },
    set: function (locale) {
        i18n.locale = locale;
        VeeValidate.Validator.localize(locale);
    }
});

import VeeValidate from "vee-validate";
const phoneOrEmailRule = {
    getMessage(field, args) {
        return `The ${field} must be either a valid phone number or e-mail`;
    },
    validate(value, args) {

        const EMAILREG  = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return EMAILREG.test(value) || value >= 10 ;
    }
};

VeeValidate.Validator.extend('phoneOrEmail', phoneOrEmailRule);
Vue.use(VeeValidate, {
    locale: localStorage.getItem('language') ? localStorage.getItem('language') : 'ua',
    dictionary: {
        ru: {
            custom: {
                login: {
                    required: () => 'Введите логин',
                    phoneOrEmail: () => 'Введите корректный email или телефон'
                },
                phone_: {
                    required: () => 'Введите телефон',
                    length: () => 'Телефон должен содержать 12 цифр',
                    min: () => 'Телефон должен содержать не менее 12 цифр',
                },
                password_: {
                    required: () => 'Введите пароль',
                },
                newPassword: {
                    required: () => 'Введите новый пароль',
                },
                confirmPassword: {
                    required: () => 'Введите новый пароль повторно',
                    confirmed: () => 'Введенные новые пароли не совпадают',
                },
                moodleLogin: {
                    required: () => 'Введите логин в Moodle',
                },
                moodlePassword: {
                    required: () => 'Введите пароль в Moodle',
                },
                inn_: {
                    required: () => 'Введите ИНН',
                },
                date_passport_from_: {
                    required: () => 'Введите дату выдачи',
                },
                date_passport_to_: {
                    required: () => 'Введите дату действительности',
                },
                country_: {
                    required: () => 'Введите страну',
                },
                address_fact_: {
                    required: () => 'Введите адресс проживания',
                },
                passport_: {
                    required: () => 'Введите серия, номер паспорта',
                },
                issued_passport_: {
                    required: () => 'Введите орган, которым был выдан документ',
                }
            }
        },
        en: {
            custom: {
                login: {
                    required: () => 'Enter login',
                    phoneOrEmail: () => 'Enter the correct email or phone'
                },
                phone_: {
                    required: () => 'Enter phone',
                    length: () => 'Phone number should contain 12 numbers',
                    min: () => 'Phone number should contain more than 10 numbers',
                },
                password_: {
                    required: () => 'Enter password',
                },
                newPassword: {
                    required: () => 'Enter a new password',
                },
                confirmPassword: {
                    required: () => 'Re-enter new password',
                    confirmed: () => 'New passwords entered do not match',
                },
                moodleLogin: {
                    required: () => 'Enter login in Moodle',
                },
                moodlePassword: {
                    required: () => 'Enter your password in Moodle',
                },
                inn_: {
                    required: () => 'Enter TIN',
                },
                date_passport_from_: {
                    required: () => 'Enter date of issue',
                },
                date_passport_to_: {
                    required: () => 'Enter validity date',
                },
                country_: {
                    required: () => 'Enter country',
                },
                address_fact_: {
                    required: () => 'Enter your address',
                },
                passport_: {
                    required: () => 'Enter passport number',
                },
                issued_passport_: {
                    required: () => 'Enter the authority to which the document was issued',
                }
            },
        },
        ua: {
            custom: {
                login: {
                    required: () => 'Введіть логін',
                    phoneOrEmail: () => 'Введіть коректний email або телефон'
                },
                phone_: {
                    required: () => 'Введіть телефон',
                    length: () => 'Телефон має містити 12 цифр',
                    min: () => 'Телефон має містити не менше 10 цифр',
                },
                password_: {
                    required: () => 'Введіть пароль',
                },
                newPassword: {
                    required: () => 'Введіть новий пароль',
                },
                confirmPassword: {
                    required: () => 'Введіть новий пароль повторно',
                    confirmed: () => 'Введені нові паролі не збігаються',
                },
                moodleLogin: {
                    required: () => 'Введіть логін в Moodle',
                },
                moodlePassword: {
                    required: () => 'Введіть пароль в Moodle',
                },
                inn_: {
                    required: () => 'Введіть ІПН',
                },
                date_passport_from_: {
                    required: () => 'Введіть дату видачі',
                },
                date_passport_to_: {
                    required: () => 'Введіть дату дійсності',
                },
                country_: {
                    required: () => 'Введіть країну',
                },
                address_fact_: {
                    required: () => 'Введіть адресу проживання',
                },
                passport_: {
                    required: () => 'Введіть серія, номер паспорта',
                },
                issued_passport_: {
                    required: () => 'Введіть орган, яким було видано документ',
                }
            }
        },
    }
});


// Plugin for popup images and videos
// import VueSilentbox from 'vue-silentbox'
// Vue.use(VueSilentbox);

// Plugin for message links
// import linkify from 'vue-linkify'
// Vue.directive('linkified', linkify);


// V-html sanitize for protection from XSS
// import VueSanitize from "vue-sanitize";
// let defaultOptions = {
//     allowedTags: ['a', 'b', 'u', 'strong'],
//     allowedAttributes: {
//         'a': [ 'href', 'target', 'class' ]
//     }
// };
// Vue.use(VueSanitize, defaultOptions);

import moment from 'moment';

Vue.filter('imgSrc', function(value) {
    if (value && value.match(/http:\/\/127.0.0.1:8000/g)) {
        return value.replace("http://127.0.0.1:8000", env.base_url)
    } else if (value && value !== '' && value !== null) {
        return value
    } else {
        return env.public_base + '/assets/images/person-icon.png'
    }
});

Vue.filter('formatDateMmDdYyyy', function(value) {
    if (value) {
        let months = Locale[i18n.locale]['months'].split(',');
        let date = moment(String(value));
        return date.format('D') + ' ' + months[date.format('M') - 1] + ' ' + date.format('HH:mm:ss');
    }
});

Vue.filter('money', function(value) {
    if (value === '--') return value;
    value = Number.isNaN(value) ? 0 : value;
    let res = value ? parseFloat(value).toFixed(2) : '0.00'
    return res + ' ' + i18n.t('uah')
});

// router.beforeEach((to, from, next) => {
//     store.dispatch('toggleSidebarLeft', false);
//     next()
// });

import App from './App.vue';
import store from './store/store';

import VueRouter from 'vue-router';
Vue.use(VueRouter);

import router from './routes';

import vuetify from './plugins/vuetify'

const app = new Vue({
    el: '#payer-app',
    vuetify,
    router,
    store,
    i18n,
    render: h => h(App),
    created(){
        document.getElementById('payer-app')
    }
});
